import "./EventScheduleSection.css";

export default function EventScheduleSection() {
  const schedule = [
    { 
      time: "11:00 - 20:00", 
      event: "Έκθεση κρασιού",
      url: null 
    },
    { 
      time: "11:00 - 20:00", 
      event: "Collage workshop",
      url: "https://www.instagram.com/this.is.how.butterflies.cum/" 
    },
    { 
      time: "11:00 - 23:00", 
      event: "Tattoo Corner by Luv n Roll",
      url: "https://www.instagram.com/luvnroll?igsh=aml6NnBsMzYwbmg2"
    },
    { 
      time: "16:00 - 20:00", 
      event: "Live art - graffiti",
      url: "https://www.instagram.com/klark_tattoo/"
    },
    { 
      time: "15:00 - 19:00", 
      event: "Mitsokool",
      url: "https://www.instagram.com/cool_dimitris?igsh=MTlrNzIxanR1YjI2cw=="
    },
    { 
      time: "19:00 - 23:00", 
      event: "Fotini Galvani (party)",
      url: "https://www.instagram.com/photinee/"
    },
  ];

  return (
    <section id="section3" className="schedule-section">
      <div className="schedule-title">
        <h2>Event Schedule</h2>
      </div>

      <div className="schedule-box">
        <ul className="schedule-list">
          {schedule.map((item, index) => (
            <li key={index} className="schedule-item">
              <span className="schedule-time">{item.time}</span>
              {item.url ? (
                <a 
                  href={item.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="schedule-event"
                >
                  {item.event}
                </a>
              ) : (
                <span className="schedule-event">{item.event}</span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}